import store from '@/store'

export function validateReferenceNumber (value) {
  if (value === '') return true

  return store
    .dispatch('validate/referenceNumber', value)
    .then(isValid => (isValid))
}
